import axios from "axios";

import { baseUrl } from "./baseUrl";

const partnerApi = axios.create({
    baseURL: `${baseUrl}/admin/partner`,
});

export const getSupportTickets = async () => {
    try {
        const response = await partnerApi.get('/support-tickets');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching support tickets:", error);
        throw error;
    }
}

export const getSupportTicketById = async (ticketId) => {
    try {
        const response = await partnerApi.get(`/support-tickets/${ticketId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching support ticket by ID:", error);
        throw error;
    }
}

export const markTicketAsResolved = async (data) => {
    try {
        const response = await partnerApi.post(`/support-ticket-resolve`, data);
        return response.data;
    } catch (error) {
        console.error("Error marking ticket as resolved:", error);
        throw error;
    }
}

export const getCampaignCreationRequests = async () => {
    try {
        const response = await partnerApi.get('/campaign-creation-requests');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign creation requests:", error);
        throw error;
    }
}

export const getCampaignRequestDetails = async (requestId) => {
    try {
        const response = await partnerApi.get(`/campaign-creation-requests/${requestId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign request details:", error);
        throw error;
    }
}

export const resolveCampaignCreationRequest = async (data) => {
    try {
        const response = await partnerApi.post(`/campaign-creation-request-resolve`, data);
        return response.data;
    } catch (error) {
        console.error("Error resolving campaign creation request:", error);
        throw error;
    }
}

export const getCampaignModificationRequests = async () => {
    try {
        const response = await partnerApi.get('/campaign-modification-requests');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign modification requests:", error);
        throw error;
    }
}

export const getCampaignModificationRequestDetails = async (requestId) => {
    try {
        const response = await partnerApi.get(`/campaign-modification-requests/${requestId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign modification request details:", error);
        throw error;
    }
}

export const resolveCampaignModificationRequest = async (data) => {
    try {
        const response = await partnerApi.post(`/campaign-modification-request-resolve`, data);
        return response.data;
    } catch (error) {
        console.error("Error resolving campaign modification request:", error);
        throw error;
    }
}